/**
 * Created by vhe on 7/25/2017.
 */
'use strict';
import angular from 'angular';
import giftCardBalanceController from './gift-card-balance.controller';
import CartService from '../../app/cart/cart.service';
export default angular.module('directives.giftCardBalance', [])
    .controller('giftCardBalanceController', giftCardBalanceController)
    .service('CartService', CartService)
    .component('giftCardBalance', {
    template: require('./gift-card-balance.html'),
    controller: giftCardBalanceController
})
    .name;
//# sourceMappingURL=index.js.map